<template>
  <b-modal
      modal-class="footer-dialog"
      data-test-path="dialog-list-of-images"
      id="bv-modal-list-of-images"
      title="List of available images"
      @close="onHide"
      data-backdrop="static" data-keyboard="false"
      size="xl"
      ref="modal"
  >
    <b-container class="px-0 mx-0" fluid="true">
      <b-row>
        <b-col style="height: 500px">
          <DataGrid2
              data-test-path="list-of-images-grid"
              style="height: 100%"
              ref="grid"
              name="listOfImagesDialog"
              :selectedIndex.sync="selectedIndex"
              :items="listOfImagesGrid"
              :columns="fields"
              :headerShowReload="false"
              select-mode="single"
              @row-selected="onRowSelected"
              :details-enable="false"
              :showDetails="false"
              filtersColsClasses="col-xl-auto col-md-auto col"
              :search="searchByName"
          >
          </DataGrid2>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{close}" class="p-0">
      <FooterNavbar data-test-path="list-of-images-dialog-footer" class="w-100">
        <CloseButton
            :read-only="readOnly"
            @close="onHide">
        </CloseButton>
        <FooterButton
            type="Save"
            @save="onOk">
        </FooterButton>
      </FooterNavbar>
    </template>
  </b-modal>
</template>

<script>
import FooterNavbar from "@/components/navbar/FooterNavbar";
import VBox from "@/components/VBox";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import DialogManager from "@/utils/DialogManager";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import {ListOfImagesDialogResult} from "@/components/dialogs/results/ListOfImagesDialogResult";

export default {
  name: "ListOfImagesDialog",
  components: {FooterButton, DataGrid2, VBox, FooterNavbar, CloseButton},

  created() { },

  async beforeMount() { },

  mounted() {
    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs["grid"];
  },

  methods: {
    async onOk() {
      if (this.resolve != null) {
        this.result = new ListOfImagesDialogResult();
        this.result.selectedItem = this.selectedItem;
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    async onHide(ev) {
      if (this.resolve != null) {
        this.result = new ListOfImagesDialogResult();
        this.result.selectedItem = this.originalItem;
        this.resolve(this.result);
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },

    reset() {
      this.result = null;
      this.resolve = null;
      this.readOnly = true;
    },

    edit() {
      this.readOnly = false;
    },

    onRowSelected(item) {
      this.selectedItem = item;
    },

    searchByName(item){
      console.log(item)
    }
  },

  data: () => ({
    fields: [
      {
        name: 'Image', size: 110, sortable: true,
        template: "<div class='d-flex align-content-center justify-content-center'> <img :src='model.downloadUrl' style='max-height: 50px; max-width: 50px;' /></div>"
      },
      {
        name: 'Name', size: 250, sortable: true,
        template: "<div>{{model.data.name}}</div>"
      }
    ],
    listOfImagesGrid: [],
    originalItem: null,
    type: null,
    resolve: null,
    result: null,
    selectedIndex: null,
    selectedItem: null,
    readOnly: true,
    attachmentLoad: null,
  })
}
</script>
